export enum LevelEnum {
  beginner = 1,
  intermediate = 2,
  advanced = 3,
  expert = 4,
}

// Reverse map for getting names from values
export const LevelLabelMap: Record<number, string> = {
  [LevelEnum.beginner]: "Beginner",
  [LevelEnum.intermediate]: "Intermediate",
  [LevelEnum.advanced]: "Advanced",
  [LevelEnum.expert]: "Expert",
};